export default {
      id: "next-usage",
      viewBox: "0 0 13 13",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#next",
      toString: function () {
        return this.url;
      }
    }